export class ActivityUAStar {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.deliveryChannel = form.deliveryChannel || []; // 投放渠道
      this.needIdCard = form.needIdCard === 0 ? 0 : 1; // 是否需要身份证0需要 1不需要
      this.isShow = form.isShow === 0 ? 0 : 1; // 是否在列表页展示0展示 1不展示
      this.isNeedCoach = form.isNeedCoach === 0 ? 0 : 1; // 是否需要教练0需要 1不需要
      this.needBodyTest = form.needBodyTest === 0 ? 0 : 1; // 是否需要体测0需要 1不需要
      this.isTop = form.isTop === 0 ? 0 : 1;
      this.actionIndicator = form.actionIndicator;
      this.activityImageVO = form.converImage;
      this.address = (form.address && form.address.id) || "";
      this.otherAddress = form.otherAddress;
      this.location =
        form.latitude && form.longitude
          ? `${form.latitude},${form.longitude}`
          : "0,0";
      this.announcement = form.announcement;
      this.time = [form.beginTime, form.endTime];
      this.coachId = form.coachSelectVO && form.coachSelectVO.id;
      this.coachIds = form.coachIds;
      this.coachSelectVO = form.coachSelectVO;
      this.coachLevel = form.coachSelectVO && form.coachSelectVO.level;
      this.content = form.content;
      this.url = form.url; // 用户名单路径
      this.excelName = form.excelName; // 用户名单文件名
      this.file = form.file; // 用户名单文件
      this.excelNameVouchers = form.excelNameVouchers || form.nameOfTheVirtualCouponExcel; // 消费者券文件名
      this.urlVouchers = form.urlVouchers; // 消费者券文件保存路径
      this.consumerVouchers = form.consumerVouchers; // 消费者券
      this.h5TotalNumber = form.h5TotalNumber; // h5活动人数
      this.participationNumber = form.participationNumber; // 活动人数
      this.isCalculationDuration = form.isCalculationDuration;
      // this.newTotalAttendance = form.newTotalAttendance;
      this.oldTotalAttendance = form.oldTotalAttendance; // 老人数
      this.alternateTotalNumber = form.alternateTotalNumber; // 候补人数
      this.maxTeam = form.maxTeam; // 最大团队数量
      this.minTeam = form.minTeam; // 最小团队数量
      this.maxTeamPeople = form.maxTeamPeople; // 最大团队人数
      this.minTeamPeople = form.minTeamPeople; // 最小团队人数
      this.movingTarget = form.movingSelectVO.map(item => item.id);
      this.name = form.name;
      this.recommendEquipments = form.equipmentSelectVO || [];
      this.differDay = form.differDay !== null ? form.differDay : 14;
      this.registrationIsOver =
        form.registrationIsOver !== null ? form.registrationIsOver : 0; // 报名截止时间
      // this.suitableForPeople = form.suitableForPeopleSelectVO.map(item => item.id); // 原来选择的人群
      this.suitsTheCrowd = form.suitsTheCrowd; // 现在输入的适合人群
      this.membershipLevel = form.membershipLevel; // 会员等级
      // this.activityFlow = form.activityFlow; // 活动流程
      // this.totalAttendance = form.totalAttendance;
      this.type = form.type;
      this.isFemaleActivity = form.isFemaleActivity;// 是否为女性专场
      this.uaEventCityId = form.uaEventCityId;
      this.status = form.status;
      this.label = form.label; // ua活动标签
    } else {
      this.clear();
    }
  }

  get time() {
    if (this.beginTime && this.endTime) {
      return [this.beginTime, this.endTime];
    } else {
      return [];
    }
  }

  set time(time) {
    if (time && Array.isArray(time) && time.length === 2) {
      this.beginTime = time[0];
      this.endTime = time[1];
    } else {
      this.beginTime = "";
      this.endTime = "";
    }
  }

  get location() {
    if (this.latitude && this.longitude) {
      return `${this.latitude},${this.longitude}`;
    } else {
      return "0,0";
    }
  }

  set location(location) {
    if (location) {
      this.latitude = location.split(",")[0];
      this.longitude = location.split(",")[1];
    } else {
      this.latitude = 0;
      this.longitude = 0;
    }
  }

  clear() {
    this.id = "";
    this.deliveryChannel = [];
    this.needIdCard = 1;
    this.isCalculationDuration = 1; // 是否计算活动时长，默认为1，1是 0否
    this.isShow = 0;
    this.needBodyTest = 0;
    this.isTop = 0;
    this.isNeedCoach = 0;
    this.actionIndicator = "";
    this.activityImageVO = {};
    this.address = "";
    this.otherAddress = "";
    this.location = "";
    this.announcement = "";
    this.time = [];
    this.coachId = "";
    this.coachIds = [];
    this.coachSelectVO = [];
    this.content = "";
    this.excelName = ""; // 用户名单文件名
    this.file = null; // 用户名单文件
    this.url = ""; // 用户名单保存路径
    this.excelNameVouchers = ""; // 消费者券文件名
    this.consumerVouchers = null; // 消费者券
    this.urlVouchers = ""; // 消费者券文件保存路径
    this.h5TotalNumber = ""; // h5活动人数
    this.participationNumber = "";
    // this.newTotalAttendance = "";
    this.oldTotalAttendance = "";
    this.alternateTotalNumber = ""; // 候补人数
    this.maxTeam = ""; // 最大团队数量
    this.minTeam = ""; // 最小团队数量
    this.maxTeamPeople = ""; // 最大团队人数
    this.minTeamPeople = ""; // 最小团队人数
    this.movingTarget = [];
    this.name = "";
    this.recommendEquipments = [];
    this.differDay = 14;
    this.registrationIsOver = 0;
    this.suitableForPeople = []; //
    this.suitsTheCrowd = "";
    this.membershipLevel = 0;
    // this.activityFlow = ""; // 活动流程
    // this.totalAttendance = "";
    this.type = 0;
    this.isFemaleActivity = 0;
    this.uaEventCityId = "";
    this.status = "";
    this.label = null;
  }
}
